import { render } from "./App.vue?vue&type=template&id=1ce9a5d8"
const script = {}

import exportComponent from "/home/aspart/Desktop/MP Connect/mp-connect-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__